function getDomainUserId() {
  const matcher = new RegExp('_sp_id\\.[a-f0-9]+=([^;]+);?')
  const matchedValue = document.cookie.match(matcher)

  if (matchedValue != null) {
    const split = matchedValue[1].split('.')
    return split[0]
  }

  return ''
}

export default getDomainUserId
